import Api from "@/services/api";

export default {
  fetchSalesidolCustomers(params) {
    return Api().get("/salesidol_customers");
  },
  fetchMayaiCustomers() {
    return Api().get("/mayai_customers");
  },
  async fetchMayaiDetails() {
    let response = await Api().get(`/mayai_details`);
    return response;
  },
  async fetchMayaiDetailsAll() {
    let response = await Api().get(`/mayai_details_all`);
    return response;
  },

  async fetchMayaiDetailsWithPagination(
    currentPage,
    perPage,
    searchText,
    category
  ) {
    let response = await Api().get(
      `/mayai_details?limit=${perPage}&skip=${(currentPage - 1) *
        perPage}&category=${category}&search=${searchText}`
    );
    console.log(searchText, category);
    return response;
  },
  async fetchMayaiCustomerDetails(customerId) {
    let response = await Api().get(`/mayai_details/${customerId}`);
    return response;
  },

  async fetchMayaiNumberDetails() {
    let response = await Api().get("/number_pool");
    return response;
  },

  async login(params) {
    //console.log("Login called");
    // console.log(params);
    let userdata = await Api().post("/login", params);
    sessionStorage.userdata = JSON.stringify(userdata.data);
    // console.log(userdata);
    // Store.commit('setUser', userdata.data);
    // this.fetchCompanyDetails();
    // return userdata;
  },

  async logout() {
    //console.log("logout called");
    let userdata = await Api().post("/logout");
    sessionStorage.removeItem("userdata");
    //console.log("user logged out");
    return userdata;
  },

  async fetchDBServiceStatus() {
    let response = await Api().get("/check_db");
    return response;
  },

  async fetchSalesidolStatus() {
    let response = await Api().get("/salesidol_check");
    return response;
  },

  async fetchNGWords() {
    let response = await Api().get("/ng_words");
    return response;
  },

  async saveNGWords(params) {
    return Api().post("/ng_words", params);
  },

  async update_mayai_status(params) {
    return Api().post("/update_mayai_status", params);
  },

  async get_mayai_per_day_calls(params) {
    return Api().post("get_mayai_per_day_calls", params);
  },

  async mayai_free_and_paid_calls(params) {
    return Api().post("mayai_free_and_paid_calls", params);
  },

  async invoice_report(params) {
    return Api().post("invoice_report", params);
  },

  async plan_change_history(params) {
    return Api().post("plan_change_history", params);
  },

  async item_change_history(param) {
    return Api().post("item_change_history", param);
  },

  async billing_list_report(param) {
    return Api().post("billing_list_report", param);
  }
};
